(function() {
	document.addEventListener("DOMContentLoaded", function() {

		var confirmBlock = document.getElementById("userEmailConfirm");
		var successBlock = document.getElementById("userEmailSuccess");
		var button;

		if(confirmBlock && successBlock) {
			button = confirmBlock.getElementsByClassName("btn")[0];

			successBlock.style.display = "none";

			button.addEventListener("click", function(event) {
				event = event || window.event;
				event.preventDefault();

				var url = this.href;
				var xhr = new XMLHttpRequest();

				this.classList.add("btn-disabled");

				// AJAX
				xhr.open('GET', url, true);
				xhr.send();
				xhr.onreadystatechange = function () {
					if (xhr.readyState != 4) return;
					if (xhr.status != 200) {
						// error
						console.error(xhr.status + ': ' + xhr.statusText);
						return;
					} else {
						//console.log(xhr.responseText);

						confirmBlock.style.display = "none";
						successBlock.style.display = "block";
					}
				}
			});
		}

		// Resend Confirmation
		/*var resend = document.getElementById("resendEmailConf");
		if(resend) ResendConfirm.init({
			button: resend,
			input: document.querySelector("input[name=email]"),
			text: "Please check your email to confirm your address"
		});*/

	});

	var ResendConfirm = (function() {
		var __private = {
			ajaxUrl: false,
			ajaxMethod: "GET",

			set(args) {
				this.button = args.button || false;
				this.input  = args.input  || false;
				this.text   = args.text   || "";
			},

			listener() {
				if(this.button && this.input) {
					this.button.addEventListener("click", function(event) {
						event = event || window.event;
						event.preventDefault();

						var action = this.href;
						var email  = __private.input.value;

						__private.ajaxUrl = action + '?email=' + email;
						__private.ajax();
					});
				}
			},

			ajax() {
				var xhr = new XMLHttpRequest();
				console.log(__private.ajaxUrl);

				xhr.open(this.ajaxMethod, this.ajaxUrl, true);
				xhr.send();
				xhr.onreadystatechange = function() {
					if (this.readyState != 4) return;
					if (this.status != 200) {
						  // if error
						console.log('------------------------------------');
						console.log('URL: ' + __private.ajaxUrl);
						console.log( 'ERROR: ' + (this.status ? this.statusText : 'request failed') );
						console.log(this);
						console.log('------------------------------------');
						return;
					} else {
						// if success
						console.log('------------------------------------');
						console.log('URL: ' + __private.ajaxUrl);
						console.log( 'SUCCESS: ' + (this.status ? this.statusText : 'request was fulfilled') );
						console.log(this);
						console.log('------------------------------------');

						//__private.button.parentElement.innerHTML = __private.text;
					}
				}
			}
		};

		return {
			init(args) {
				__private.set(args);
				__private.listener();
			}
		};
	})();

})();